import { useMediaQuery } from '@mui/material';
import { UnknownBlockList } from '../../unknown-block-list';
import { jsx as _jsx } from "react/jsx-runtime";

var MediaQueryBlock = function MediaQueryBlock(_ref) {
  var _ref$block = _ref.block,
      mediaQuery = _ref$block.mediaQuery,
      blocks = _ref$block.blocks,
      href = _ref.href,
      leafBlocks = _ref.leafBlocks;
  return useMediaQuery(mediaQuery !== null && mediaQuery !== void 0 ? mediaQuery : '') ? /*#__PURE__*/_jsx(UnknownBlockList, {
    blocks: blocks,
    href: href,
    leafBlocks: leafBlocks
  }) : null;
};

export default MediaQueryBlock;